export const hasBrowserNotificationsEnabled = () => {
  return 'Notification' in window && Notification.permission === NotificationPermissionEnum.GRANTED
}

export enum NotificationPermissionEnum {
  GRANTED = 'granted',
  DEFAULT = 'default',
  DENIED = 'denied'
}
